module.exports = __webpack_public_path__ + "img/receipt_bg_bottom.9fd424d7.svg";